import { render, staticRenderFns } from "./DamageLocatorTruck.vue?vue&type=template&id=170ec9ee&scoped=true&"
import script from "./DamageLocatorTruck.vue?vue&type=script&lang=ts&"
export * from "./DamageLocatorTruck.vue?vue&type=script&lang=ts&"
import style0 from "./DamageLocatorTruck.vue?vue&type=style&index=0&id=170ec9ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170ec9ee",
  null
  
)

export default component.exports